import { is } from 'ramda'
import type { CustomEventsContext } from '../types'

const TIMEOUT = 60 * 1000 // 60 minutes in ms

// data structure: { version: int | undefined, owned_subscriptions: Array<{ receipt: Base64 string, signature: Base64 string }> }

export default function (this: CustomEventsContext, payload: Record<string, unknown>) {
  return this.sendEventWithCallback(
    'subscription.owned.android',
    payload,
    TIMEOUT
  ).then((data: unknown) => {
    const d = data as { owned_subscriptions?: unknown }
    if (is(Array, d.owned_subscriptions)) {
      return data
    }
    return Promise.reject(
      new Error(this.ERROR_UNKNOWN)
    )
  })
}
